module.exports = __webpack_public_path__ + "site/img/64.5ba881c4.jpg";